import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/ai-apis"
    path="business/ai-apis"
    element={<AsyncPage />}
  />,
];
